import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { SupportingItemChecklist } from '@/features/jobs/details/components/DocumentsCard/SupportingItemChecklist'
import {
  formatSupportingItemProvidedText,
  getSupportingItemPressTarget,
} from '@/features/jobs/details/components/DocumentsCard/SupportingItemChecklist/supporting-item-checklist-targets'

export interface SupportingItemChecklistContainerProps {
  vm: JobDetailsViewModel
}

export const SupportingItemChecklistContainer = observer(
  function SupportingItemChecklistContainer({
    vm,
  }: SupportingItemChecklistContainerProps) {
    return (
      <SupportingItemChecklist
        sections={vm.documentsVm.supportingItems.map((section) => ({
          name: section.name,
          heading: section.heading,
          completedCount: section.completedCount,
          totalCount: section.totalCount,
          items: section.requestedSupportingItems.map((item) => {
            const target = getSupportingItemPressTarget(item)
            return {
              name: item.name,
              required: item.required,
              completed: item.completed,
              adHoc: item.adHoc,
              providedText: formatSupportingItemProvidedText(item),
              revealsCapturedInformation: target?.type === 'capturedInfo',
              onPress:
                target === null
                  ? undefined
                  : target.type === 'capturedInfo'
                    ? () =>
                        vm.detailsVm.capturedInformationTabController.change(
                          target.tab,
                        )
                    : () =>
                        vm.documentsVm.documentsTabController.change(
                          'Documents',
                        ),
            }
          }),
        }))}
      />
    )
  },
)
